import { useTranslation } from "react-i18next";
import { GridColDef, GridColumnHeaderParams, GridRenderCellParams } from "@mui/x-data-grid-pro";

import { LoadingSkeleton } from "../../../components/LoadingSkeleton";
import { TableAllWastesCell } from "../../../components/TableAllWastesCell";
import { TableDateCell } from "../../../components/TableDateCell";
import { TableDownloadCYVisitReceiptCell } from "../../../components/TableDownloadCYVisitReceiptCell";
import { TablePaymentStatusIndicatorCell } from "../../../components/TablePaymentStatusIndicatorCell";
import { TablePriceCell } from "../../../components/TablePriceCell";
import { TableWeightCell } from "../../../components/TableWeightCell";
import { IColumnValuePair } from "../../../types/table";
import { getTableColumnUtils } from "../../../utils/tables/getTableColumnUtils";
import { columnLabels, ColumnType } from "./collectionYardsVisitsDetailTableColumnTypes";
import { CollectionYardsVisitsDetailTableHeaderCell } from "./CollectionYardsVisitsDetailTableHeaderCell";

const columnFlexValuePairs: IColumnValuePair<ColumnType>[] = [
  {
    name: ColumnType.created,
    value: 2,
  },
  {
    name: ColumnType.collectionYardName,
    value: 3,
  },
  {
    name: ColumnType.wasteTypes,
    value: 3,
  },
  {
    name: ColumnType.priceSum,
    value: 2,
  },
  {
    name: ColumnType.wasteSum,
    value: 2,
  },
  {
    name: ColumnType.paid,
    value: 2,
  },
];

const columnMinWidthValuePairs: IColumnValuePair<ColumnType>[] = [];

export const useGetCollectionYardsVisitsDetailTableColumns = () => {
  const { t } = useTranslation();
  const { getFlex, getWidth } = getTableColumnUtils();

  const columns: GridColDef[] = columnLabels.map((label) => {
    const columnObject: GridColDef = {
      field: label,
      headerName: t(label),
      type: "string",
      renderHeader: (params: GridColumnHeaderParams) => {
        return <CollectionYardsVisitsDetailTableHeaderCell params={params} />;
      },
      flex: getFlex(label, columnFlexValuePairs),
      minWidth: getWidth(label, columnMinWidthValuePairs),
    };

    columnObject.renderCell = (params: GridRenderCellParams) => {
      if (params.row.isMocked) {
        return <LoadingSkeleton />;
      }

      switch (label) {
        case ColumnType.created:
          return <TableDateCell params={params} />;
        case ColumnType.wasteTypes:
          return <TableAllWastesCell params={params} />;
        case ColumnType.priceSum:
          return <TablePriceCell params={params} />;
        case ColumnType.wasteSum:
          return <TableWeightCell params={params} />;
        case ColumnType.paid:
          return (
            <TableDownloadCYVisitReceiptCell visitId={params.row.visitId} priceSum={params.row.priceSum}>
              <TablePaymentStatusIndicatorCell params={params} withPaidText />
            </TableDownloadCYVisitReceiptCell>
          );
        default:
          break;
      }
    };

    return columnObject;
  });

  return columns;
};
